import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Lakeside from "./sections/Lakeside";
import Paradise from "./sections/Paradise";
import Benefits from "./sections/Benefits";
import ContactHero from "./sections/ContactHero";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Lakeside />
      <Paradise />
      <Benefits />
      <ContactHero />
      <Testimonials />
      <Footer />
    </div>;
}